'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _maybe = require('./maybe');

var _maybe2 = _interopRequireDefault(_maybe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = transformer;


function transformer(ops) {
  return function (data, withPaths) {
    return ops.reduce(function (acc, f) {
      return f(acc);
    }, { data: (0, _maybe2.default)(data), path: (0, _maybe2.default)([]), withPaths: withPaths });
  };
}
module.exports = exports['default'];